export var products = [
    {
        "title": "Brand New product 6",
        "url": "/images/product1.jpg",
        "price": 101,
        "rating": "1",
        id: "prodcutg",
    },
    {
        "title": "Brand New product 2",
        "url": "/images/product2.jpg",
        "price": 50,
        id: "prodcuth",
        rating: 5
    }, {
        "title": "Brand New product 3",
        "url": "/images/product3.jpg",
        "price": 34,
        id: "prodcuti",
        rating: 2,
    },
    {
        "title": "Brand New product 4",
        "url": "/images/product4.jpg",
        "price": 99,
        id: "prodcutj",
        rating: 3,
    }, {
        "title": "Brand New product 5",
        "url": "/images/product5.jpg",
        "price": 89,
        id: "prodcutk",
        rating: 1,
    },
    {
        "title": "Brand New product 6",
        "url": "/images/product6.jpg",
        "price": 89,
        id: "prodcutl",
        rating: 1,
    },
];